export default __webpack_public_path__ + "static/media/Manrope-Regular.c95466c5.woff";